import { IRootState } from 'reducers';
import { createSelector } from 'reselect';

export const linkSharingDrawerSelector = (state: IRootState) => state.linkSharingDrawer;

export const chosenAcademicYearOptionsSelector = (state: IRootState) =>
  linkSharingDrawerSelector(state).chosenAcademicYearOptions;
export const academicYearsTouchedSelector = (state: IRootState) =>
  linkSharingDrawerSelector(state).academicYearsTouched;
export const activeFormatSelector = (state: IRootState) => linkSharingDrawerSelector(state).activeFormat;

export const chosenYearsSelector = createSelector([chosenAcademicYearOptionsSelector], (options) =>
  options.map((option) => option.value),
);
